import { useState, useEffect, useCallback } from 'react';

/**
 * Hook for managing cooldown timers
 * @param seconds - Cooldown duration in seconds
 * @returns Object with remaining seconds, start function, and isActive flag
 */
export function useCooldown(seconds: number) {
  const [remaining, setRemaining] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (remaining > 0) {
      setIsActive(true);
      const timer = setTimeout(() => {
        setRemaining((prev) => {
          if (prev <= 1) {
            setIsActive(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [remaining]);

  const start = useCallback(() => {
    setRemaining(seconds);
    setIsActive(true);
  }, [seconds]);

  return { remaining, start, isActive };
}

